import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useErLeder, BUTIKK_VALG } from './employeeAccess';
import BareLeder from './components/BareLeder';
import RolleValg from './components/RolleValg';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


function EmployeeForm() {
    const [formData, setFormData] = useState({
        navn: '',
        telefon: '',
        epost: '',
        tilgang: 'ansatt', // Standard tilgangsnivå
        butikk: '', // Nytt felt for butikk
        roller: [],
    });

    const navigate = useNavigate();
    const leder = useErLeder();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}/employees`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                navigate('/employee-list'); // Navigerer tilbake til listen over ansatte
            } else {
                console.error('Feil ved opprettelse av ansatt');
            }
        } catch (error) {
            console.error('Feil ved kommunikasjon med serveren:', error);
        }
    };

    if (!leder) return <BareLeder tekst="Bare en leder kan legge til ansatte." />;

    return (
        <div className="max-w-5xl mx-auto py-8 bg-white shadow-lg rounded-lg p-6 mb-4">
            <h2 className="text-3xl font-bold mb-6 text-center">Registrer Ny Ansatt</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="ansatt-navn" className="block text-sm font-medium text-gray-700">Navn</label>
                    <input
                        type="text"
                        id="ansatt-navn"
                        name="navn"
                        value={formData.navn}
                        onChange={handleChange}
                        required
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    />
                </div>
                <div>
                    <label htmlFor="ansatt-telefon" className="block text-sm font-medium text-gray-700">Telefon</label>
                    <input
                        type="tel"
                        id="ansatt-telefon"
                        name="telefon"
                        value={formData.telefon}
                        onChange={handleChange}
                        required
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    />
                </div>
                <div>
                    <label htmlFor="ansatt-epost" className="block text-sm font-medium text-gray-700">E-post</label>
                    <input
                        type="email"
                        id="ansatt-epost"
                        name="epost"
                        value={formData.epost}
                        onChange={handleChange}
                        required
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    />
                </div>
                <div>
                    <label htmlFor="ansatt-tilgang" className="block text-sm font-medium text-gray-700">Tilgang</label>
                    <select
                        id="ansatt-tilgang"
                        name="tilgang"
                        value={formData.tilgang}
                        onChange={handleChange}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    >
                        <option value="ansatt">Ansatt</option>
                        <option value="leder">Leder</option>
                    </select>
                </div>
                <RolleValg
                    roller={formData.roller || []}
                    onChange={(roller) => setFormData((prevData) => ({ ...prevData, roller }))}
                />
                <div>
                    <label htmlFor="ansatt-butikk" className="block text-sm font-medium text-gray-700">Butikk</label>
                    <select
                        id="ansatt-butikk"
                        name="butikk"
                        value={formData.butikk}
                        onChange={handleChange}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    >
                        <option value="">Velg butikk</option>
                        {BUTIKK_VALG.map((b) => <option key={b} value={b}>{b}</option>)}
                    </select>
                </div>
                <div className="text-center">
                    <button type="submit" className="bg-green-700 text-white px-6 py-2 rounded hover:bg-green-800">
                        Registrer Ansatt
                    </button>
                </div>
            </form>
        </div>
    );
}

export default EmployeeForm;
